import { useState } from "react";
import { router } from "@inertiajs/react";
import Header from "../Component/Header";

export default function Create() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        mem_code: "",
        mem_phone: "",
    });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const setField = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const submit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        setErrors({});

        try {
            const formData = new FormData();
            formData.append("name", form.name);
            formData.append("email", form.email);
            formData.append("mem_code", form.mem_code);
            formData.append("mem_phone", form.mem_phone);

            await window.axios.post(
                "/panel/members",
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            router.visit("/panel/members");
        } catch (error) {
            setErrors(error?.response?.data?.errors ?? {});
        } finally {
            setSubmitting(false);
        }
    };

    const getError = (path) => errors[path];

    return (
        <>
            <Header />
            <main id="content" className="pb-14 sm:pb-16">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto">
                    <div className="py-2 sm:pb-0 sm:pt-5 space-y-5">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-5">
                            <div className="inline-flex sm:justify-end items-center gap-x-3">
                                <p className="text-sm text-muted-foreground-1">Member</p>
                            </div>
                        </div>

                        <form onSubmit={submit} className="grid grid-cols-1 lg:grid-cols-6 gap-5">
                            <div className="lg:col-span-4 space-y-4">
                                <div className="flex flex-col bg-card border border-card-line overflow-hidden rounded-xl shadow-2xs">
                                    <div className="py-3 px-5 flex justify-between items-center gap-x-5 border-b border-card-header">
                                        <h2 className="inline-block font-semibold text-foreground">
                                            Create Member
                                        </h2>
                                    </div>

                                    <div className="p-5 space-y-5">
                                        <div>
                                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-foreground">
                                                Full Name
                                            </label>
                                            <input
                                                id="name"
                                                type="text"
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                                placeholder="Input full name"
                                                value={form.name}
                                                onChange={(e) => setField("name", e.target.value)}
                                            />
                                            {getError("name") && (
                                                <p className="mt-1 text-xs text-red-600">{getError("name")}</p>
                                            )}
                                        </div>

                                        <div>
                                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-foreground">
                                                Email
                                            </label>
                                            <input
                                                id="email"
                                                type="email"
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                                placeholder="name@email.com"
                                                value={form.email}
                                                onChange={(e) => setField("email", e.target.value)}
                                            />
                                            {getError("email") && (
                                                <p className="mt-1 text-xs text-red-600">{getError("email")}</p>
                                            )}
                                        </div>

                                        <div>
                                            <label htmlFor="mem_code" className="block mb-2 text-sm font-medium text-foreground">
                                                Member Code
                                            </label>
                                            <input
                                                id="mem_code"
                                                type="text"
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                                placeholder="e.g. MEM-0001"
                                                value={form.mem_code}
                                                onChange={(e) => setField("mem_code", e.target.value)}
                                            />
                                            {getError("mem_code") && (
                                                <p className="mt-1 text-xs text-red-600">{getError("mem_code")}</p>
                                            )}
                                        </div>

                                        <div>
                                            <label htmlFor="mem_phone" className="block mb-2 text-sm font-medium text-foreground">
                                                Phone
                                            </label>
                                            <input
                                                id="mem_phone"
                                                type="text"
                                                className="py-2 px-3 block w-full bg-layer border border-layer-line rounded-lg sm:text-sm text-layer-foreground placeholder:text-muted-foreground-1 focus:border-primary-focus focus:ring-primary-focus"
                                                placeholder="e.g. 08123456789"
                                                value={form.mem_phone}
                                                onChange={(e) => setField("mem_phone", e.target.value)}
                                            />
                                            {getError("mem_phone") && (
                                                <p className="mt-1 text-xs text-red-600">{getError("mem_phone")}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={() => router.visit("/panel/members")}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-layer border border-layer-line text-layer-foreground hover:bg-layer-hover"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={submitting}
                                        className="py-2 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg bg-primary border border-primary-line text-primary-foreground hover:bg-primary-hover disabled:opacity-50 disabled:pointer-events-none"
                                    >
                                        {submitting ? "Saving..." : "Save Member"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
}
